import { API } from "aws-amplify"
import { useState, useEffect } from "react"

const POLL_MS = 2000
const MAX_POLLS = 150 // 5 min, past the async Lambda timeout
const TERMINAL = ["DONE", "ERROR"]

export const useProcess = (PK, SK) => {
  const [process, setProcess] = useState(null)

  useEffect(() => {
    const [organizationId, projectId] = PK.split("#")
    let timer
    let stopped = false
    let polls = 0

    const poll = async () => {
      polls += 1
      try {
        const res = await API.get(
          "CORE",
          `/pdf/process/${organizationId}/${projectId}/${SK}`,
        )
        if (stopped) return
        setProcess(res)
        if (TERMINAL.includes(res.status)) return
      } catch (error) {
        console.log(`useProcess(${PK}, ${SK}): ${error}`)
      }
      if (stopped) return
      if (polls >= MAX_POLLS) {
        setProcess(prev => ({ ...prev, status: "ERROR" }))
        return
      }
      timer = setTimeout(poll, POLL_MS)
    }

    poll()
    return () => {
      stopped = true
      clearTimeout(timer)
    }
  }, [PK, SK])

  return [process, setProcess]
}
